(function () {
  const isRequestQuotePage = window.location.pathname.includes("pages/request-a-quote");

  function cloneProductFieldTitle() {
    const productsDivs = document.querySelectorAll('div[id*="product-container"]');
    if (productsDivs.length >= 1) {
      productsDivs.forEach((div, index) => {
        const newDiv = div.cloneNode(true);
        const newInput = newDiv.querySelector('input[id*="contact_product"]');
        const newLabel = newDiv.querySelector("label");
        const newRemoveItemButton = newDiv.querySelector("#remove-product");
        const lastProductDiv = productsDivs.length - 1;
        const newProductIndex = productsDivs.length + 1;
        newDiv.id = `product-container-${newProductIndex}`;
        if (index === lastProductDiv) {
          newLabel.outerHTML = `<label for="contact_product-${newProductIndex}">Product ${newProductIndex}</label>`;
          newInput.id = `contact_product-${newProductIndex}`;
          newInput.name = `contact[product-${newProductIndex}]`;
          newInput.placeholder = `Product #${newProductIndex}`;
          newInput.value = "";
          newRemoveItemButton.addEventListener("click", () => removeProductTitle(newRemoveItemButton));
          newInput.removeAttribute("inserted-by-quote");
          div.insertAdjacentElement("afterend", newDiv);
        }
      });
    }
  }

  function insertNewProductFromStorage(productTitle) {
    const productsDivs = document.querySelectorAll('div[id*="product-container"]');
    productsDivs.forEach((div, index) => {
      const newDiv = div.cloneNode(true);
      const newInput = newDiv.querySelector('input[id*="contact_product"]');
      const newLabel = newDiv.querySelector("label");
      const lastProductDiv = productsDivs.length - 1;
      const newProductIndex = productsDivs.length + 1;
      newDiv.id = `product-container-${newProductIndex}`;
      if (index === lastProductDiv) {
        newLabel.outerHTML = `<label for="contact_product-${newProductIndex}">Product ${newProductIndex}</label>`;
        newInput.id = `contact_product-${newProductIndex}`;
        newInput.name = `contact[product-${newProductIndex}]`;
        newInput.placeholder = `Product #${newProductIndex}`;
        newInput.value = productTitle;
        newInput.setAttribute("inserted-by-quote", "true");
        div.insertAdjacentElement("afterend", newDiv);
      }
    });
  }

  function populateInputs() {
    const storageFormValues = window.localStorage.getItem("formValues");
    if (storageFormValues) {
      const FormValuesObject = JSON.parse(storageFormValues);
      const form = document.getElementById("contact_form");
      form.querySelector("#contact_name_contact").value = FormValuesObject.firstName;
      form.querySelector("#contact_last_name_contact").value = FormValuesObject.lastName;
      form.querySelector("#contact_email_contact").value = FormValuesObject.email;
      form.querySelector("#contact_phone-number").value = FormValuesObject.phoneNumber;
      form.querySelector("#contact_message").value = FormValuesObject.message;
    }
  }

  function reorderInputsProducts() {
    const productsInputContainer = document.querySelectorAll('div[id*="product-container"]');
    productsInputContainer.forEach((div, index) => {
      const label = div.querySelector("label");
      const input = div.querySelector("input");
      const newIndex = index + 1;
      if (index === 0) {
        div.id = "product-container";
        label.outerHTML = '<label for="contact_product-1">Product 1</label>';
        input.id = "contact_product-1";
        input.placeholder = "Product #1";
      } else {
        div.id = `product-container-${newIndex}`;
        label.outerHTML = `<label for="contact_product-${newIndex}">Product ${newIndex}</label>`;
        input.id = `contact_product-${newIndex}`;
        input.placeholder = `Product #${newIndex}`;
      }
    });
  }

  function removeProductTitle(removeButton) {
    const inputDiv = removeButton.parentNode;
    const divToRemove = inputDiv.parentNode;
    const input = inputDiv.querySelector("input");
    const inputInsertedByQuote = input.getAttribute("inserted-by-quote");
    const productsToQuoteStorage = window.localStorage.getItem("productsToQuote");
    const productsDivs = document.querySelectorAll('div[id*="product-container"]');

    if (inputInsertedByQuote && productsToQuoteStorage) {
      const inputValue = input.value;
      let productsToQuoteStorageArray = JSON.parse(productsToQuoteStorage);
      productsToQuoteStorageArray = productsToQuoteStorageArray.filter(
        (product) => product.productTitle !== inputValue
      );
      window.localStorage.setItem("productsToQuote", JSON.stringify(productsToQuoteStorageArray));
      document.querySelectorAll("[get-a-quote-header] span").forEach((span) => {
        span.innerHTML = `(${productsToQuoteStorageArray.length})`;
      });
    }

    if (productsDivs.length >= 2) {
      divToRemove.remove();
      reorderInputsProducts();
    } else {
      productsDivs.forEach((div) => div.querySelector("input").value = "");
    }
  }

  if (isRequestQuotePage) {
    document.querySelector("#add-product").addEventListener("click", cloneProductFieldTitle);

    const productsToQuoteStorage = window.localStorage.getItem("productsToQuote");
    if (productsToQuoteStorage) {
      const productsToQuoteStorageArray = JSON.parse(productsToQuoteStorage);
      productsToQuoteStorageArray.forEach((product, index) => {
        const input = document.querySelectorAll('input[id*="contact_product"]')[index];
        if (input) {
          input.value = product.productTitle;
          input.setAttribute("inserted-by-quote", "true");
        } else {
          insertNewProductFromStorage(product.productTitle);
        }
      });
    }

    document.querySelectorAll("#remove-product").forEach((btn) =>
      btn.addEventListener("click", () => removeProductTitle(btn))
    );

    populateInputs();

    window.addEventListener("beforeunload", function () {
      const form = document.getElementById("contact_form");
      const formObject = {
        firstName: form.querySelector("#contact_name_contact").value,
        lastName: form.querySelector("#contact_last_name_contact").value,
        email: form.querySelector("#contact_email_contact").value,
        phoneNumber: form.querySelector("#contact_phone-number").value,
        message: form.querySelector("#contact_message").value,
      };
      window.localStorage.setItem("formValues", JSON.stringify(formObject));

      const productsInputs = document.querySelectorAll('input[id*="contact_product"]');
      const productsObj = [];
      productsInputs.forEach((productInput) => {
        if (productInput.value !== "") {
          productsObj.push({ productTitle: productInput.value });
        }
      });
      window.localStorage.setItem("productsToQuote", JSON.stringify(productsObj));
    });
  }

  function updateGetAQuoteButton() {
    const allGetAQuoteButtons = document.querySelectorAll("[get-a-quote-header]");
    const productsToQuoteStorage = window.localStorage.getItem("productsToQuote");
    const count = productsToQuoteStorage ? JSON.parse(productsToQuoteStorage).length : 0;

    allGetAQuoteButtons.forEach((btn) => {
      const span = btn.querySelector("span");
      if (count > 0) {
        btn.innerHTML = `Complete the Quote <span>(${count})</span>`;
      } else {
        if (span) span.remove();
      }
    });
  }

  function addToQuoteHandle(productHandle, addQuoteButton) {
    fetch(`/products/${productHandle}.js`)
      .then((res) => res.json())
      .then((productData) => {
        const productTitle = productData.title;
        let productsToQuoteStorage = window.localStorage.getItem("productsToQuote");
        if (!productsToQuoteStorage) {
          window.localStorage.setItem("productsToQuote", JSON.stringify([{ productTitle }]));
        } else {
          const productsToQuoteStorageArray = JSON.parse(productsToQuoteStorage);
          if (!productsToQuoteStorageArray.some((p) => p.productTitle === productTitle)) {
            productsToQuoteStorageArray.push({ productTitle });
            window.localStorage.setItem("productsToQuote", JSON.stringify(productsToQuoteStorageArray));
          }
        }
        updateGetAQuoteButton();
        addQuoteButton.innerHTML = "Added to Quote ✓";
      });
  }

  document.querySelectorAll("#add-to-quote").forEach((btn) => {
    const productHandle = btn.getAttribute("handle");
    btn.addEventListener("click", () => addToQuoteHandle(productHandle, btn));
  });

  updateGetAQuoteButton();
})();